export const BTN_VISUAL_TYPES = ['primary', 'secondary', 'menu', 'social', 'answer'];
export const defaultColors = {
  primary: 'green',
  link: 'black',
  'icon-link': 'black',
  flat: 'grey',
  add: 'default'
};